import React from 'react'
import SocialLinkComponent from './SocialLinkComponent';
import FacebookSvg from '../svg/FacebookSvg';
import InstagramSvg from '../svg/InstagramSvg';
import { FACEBOOK_URL, INSTAGRAM_URL } from '../constants';

const SocialsGroupComponent = ({ primary}) => {

    return (
        <>
            <SocialLinkComponent
                href={FACEBOOK_URL}
                primary={primary}
                Icon={FacebookSvg}
                alt='Facebook'
            />
            <SocialLinkComponent
                href={INSTAGRAM_URL}
                primary={primary}
                Icon={InstagramSvg}
                alt='Instagram'
            />
        </>
    )
}


export default React.memo(SocialsGroupComponent);